//import 'parsleyjs/dist/parsley.min.js';
//mport 'parsleyjs/dist/i18n/pl.js';
import 'slick-carousel';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import Swal from 'sweetalert2'
import 'jquery.preloader/src/js/jquery.preloader.min.js';
import Rellax from 'rellax/rellax.js';


$(document).ready(function () {

   $('body').on('click', 'a.ac_box', function(event) {
    var active = 0;
      if($(this).hasClass('active')){
        active == 1;
      }
      $('.accordion a').removeClass('active');
      $('.accordion li').removeClass('active');
      $('.accordion ul').removeClass('active');
      if(active == 0){
        $(this).addClass('active');
        $(this).closest('li').addClass('active');
        $(this).closest('ul').addClass('active');
      }
    event.preventDefault();
    });

   $('body').on('click', 'a.ac_box.active', function(event) {
    $('.accordion a').removeClass('active');
      $('.accordion li').removeClass('active');
      $('.accordion ul').removeClass('active');
    event.preventDefault();
   });
  var rellax = new Rellax('.rellax', {
    center:true
  });

  $('.slick').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    nextArrow: '.s_arr_right',
    prevArrow: '.s_arr_left',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 560,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });

  $(document).on('keyup', '.postcode', function(e){
      var code = $(this).val();
      var key = event.keyCode || event.charCode;

      if($(this).val().length == 2){
         if( key == 8 || key == 46 ){
         }
         else{
          $(this).val(code+'-');
         }
      }
      if($(this).val().indexOf('--') !== -1){
        $(this).val(code.replace('--','-'));
      }
  });








/*
    $('body').on('click', '.btn__tolltip', function(event) {
      event.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().toggleClass('active');
    });

    if ($('#formlp').length > 0) {
      var $formlp = $('#formlp');
      $formlp.submit(function(event) {
        $('#formlp').preloader();
        $.ajax({
          data: $formlp.serialize(), //{ action: 'formlp', name: $name, phone: $phone, email: $email, accept: $accept, accept_marketing: $accept_marketing, page_id: pid},
           type: 'post',
           dataType: 'JSON',
           url: '/mail.php',
           fail: function() {
              $('#formlp').preloader('remove');
              Swal.fire({
                icon: 'error',
                title: 'Bład.',
                text: 'Something went wrong!',
                showConfirmButton: true,
                confirmButtonText:'<i class="fa fa-thumbs-up"></i> OK!',
              });
              setTimeout(function(){
                window.location.reload();
              }, 2800);
          },
          error: function(){
              $('#formlp').preloader('remove');
              Swal.fire({
                icon: 'error',
                title: 'Bład.',
                text: 'Something went wrong!',
                showConfirmButton: true,
                confirmButtonText:'<i class="fa fa-thumbs-up"></i> OK!',
              });
              setTimeout(function(){
                window.location.reload();
              }, 2800);
          },
           success: function(result) {
              if (result.success == 1) {
                  $formlp.find('input[type=text], input[type=email], input[type=phone], textarea').val('');
                  $formlp.find('input:checkbox').removeAttr('checked');
                  Swal.fire({
                    icon: 'success',
                    title: 'Dziękujemy.',
                    text: 'Twoja wiadomość została wysłana.',
                    showConfirmButton: false,
                    timer: 2500,
                  });
                  setTimeout(function(){
                 //   window.location.reload();
                  }, 2800);


              } else {
                 Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Coś poszło nie tak!',
                  });
              }
              $('#formlp').preloader('remove');
            // console.log('Rezultat: ' + result.info);
          },
        });
        event.preventDefault();
      });
    }
*/
});